<template lang="pug">
    include Uploader.pug
</template>

<script>

export default {
    name: 'Uploader',
    data() {
        // Data contained on the component
        return {
        };
    }
}

</script>

<style scoped lang="scss">
@importy "Uploader";
</style>



// WEBPACK FOOTER //
// src/components/uploader/Uploader.vue